import styled from 'styled-components';

const Divider = styled.div`
	height: 1px;
	opacity: 0.1;
	background-color: #fff;
`;

export { Divider };
